import { ImgxAttr, imageAttr } from '@vestiaire/vc-angular-lib';
import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { SetPageParams } from '@app/core/header/store/actions';

@Component({
  selector: 'vc-affiliation-page',
  templateUrl: './affiliation-page.component.html',
  styleUrls: ['./affiliation-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class AffiliationPageComponent {
  public overrideImgxUrl = 'https://assets-images.vestiairecollective.com';

  public baseImgxAttrs = [
    new ImgxAttr('auto', imageAttr.F),
    new ImgxAttr('crop', imageAttr.Fit),
    new ImgxAttr(2, imageAttr.Dpr)
  ];

  public affiliateImgxAttrs = [
    new ImgxAttr('auto', imageAttr.F),
    new ImgxAttr('crop', imageAttr.Fit),
    new ImgxAttr(420, imageAttr.H),
    new ImgxAttr(840, imageAttr.W),
    new ImgxAttr(2, imageAttr.Dpr)
  ];

  constructor(private store: Store<IAppState>) {
    this.store.dispatch(new SetPageParams({ pageType: 'affiliation' }));
  }
}
